export default __webpack_public_path__ + "static/media/GelBox.f3ebb1ad.svg";